import {
  Button,
  Icon,
  Input,
  Spin,
  Table,
  Row,
  Dropdown,
  Menu,
  Upload,
  Popconfirm,
  Empty,
} from "antd";
import React, { Fragment } from "react";
import Highlighter from "react-highlight-words";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./AccountMSISDN.css";
import history from "../../utils/history";
import { FileService } from "../../services/file/FileService";

import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import i18next from "i18next";

class AccountMSISDNTable extends React.Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("accountMSISDNTable");
    this.fileService = new FileService();
    this.accountService = new AccountService();
    this.state = {
      isFetching: false,
      searchText: "",
      data: [],
      file: null,
      uploading: false,
      pagination:{
        current: 1,
        pageSize: 10,
        total: 0,
      }
    };
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={this.state.searchText}
          onChange={(e) =>{
            setSelectedKeys(e.target.value ? [e.target.value] : [])
            this.setState({searchText: e.target.value ? e.target.value : ""})
          }
          }
          onPressEnter={() => this.handleSearch(this.state.searchText, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(this.state.searchText, confirm)}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (searchText, confirm) => {
    confirm();
    // this.setState({ searchText: searchText});
    this.getAllAccountMSISDN(1,searchText);
    this.setState({pagination:{...this.state.pagination,current:1}})

  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
    this.getAllAccountMSISDN(1,"");
    this.setState({pagination:{...this.state.pagination,current:1}})


  };

  componentDidMount() {
    this.getAllAccountMSISDN(1,"");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async getAllAccountMSISDN(page,msisdn) {
    try {
      this.setState({ isFetching: true });
      let data = await this.accountService.viewAllAccountMSISDN(page-1,10,msisdn,
        this.props.context.session_id
      );
      this.setState({ data: this.formatData(data),pagination:{...this.state.pagination, total:data.totalRecords}, isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  formatData(data) {
    const updated_data = [];
    console.log(data.ivrList)
    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["msisdn"] = data.ivrList[i]["msisdn"];
      row["status"] =
        data.ivrList[i]["status"] == "ACT" ? "Active" : "Reserved";
      updated_data.push(row);
    }
    
    return updated_data;
  }

  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item>
          <Popconfirm
            title="Are you sure delete this Account?"
            onConfirm={() => this.deleteAccountMSISDN(record)}
            okText="Yes"
            cancelText="No"
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              Delete
              <Icon className={"delete-account-style"} type="delete" />
            </a>
          </Popconfirm>
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }

  async handleDownload() {
    try {
      let response = await this.fileService.downloadMsisdnTemp(
        this.props.context.session_id,
        "CSV"
      );
    } catch (e) {
      handleError(e);
    }
  }

  async deleteAccountMSISDN(record) {
    try {
      let data = await this.accountService.deleteAccountMSISDN(
        this.props.context.session_id,
        record.msisdn
      );
      showSuccessToast("Deleted successfully");
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  addAccountMSISDN = () => {
    history.push("/home/accounts/createAccountMSISDN");
  };

  handleRefresh() {
    this.getAllAccountMSISDN();
  }

  handleCancel = () => {
    this.setState({
      file: null,
      uploading: false,
    });
  };

  handleUpload = async () => {
    this.setState({
      uploading: true,
    });

    let session_id = this.props.context.session_id;

    try {
      let response = await this.fileService.uploadMsisdnBatch(
        session_id,
        this.state.file
      );
      this.setState({
        file: null,
        uploading: false,
      });
      showSuccessToast("uploaded successfully");
      this.getAllAccountMSISDN();
    } catch (e) {
      this.setState({
        uploading: false,
      });
      handleError(e);
    }
  };

  handleTableChange=(pagination)=>{
    this.setState({pagination:pagination});
    this.getAllAccountMSISDN(pagination.current,this.state.searchText)
  }
  render() {
    const columns = [
      {
        title: "010hotline Number",
        dataIndex: "msisdn",
        key: "msisdn",
        width: "40%",
        ...this.getColumnSearchProps("msisdn"),
      },
      // {
      //   title: "Action",
      //   key: "copy",
      //   width: "20%",
      //   render: (text, record) => (
      //     <Button
      //       icon="copy"
      //       onClick={() => {
      //         navigator.clipboard.writeText(record.msisdn);
      //         showSuccessToast("010hotline number copied to clipboard");
      //       }}
      //     >
      //       Copy
      //     </Button>
      //   ),
      // },
      // {
      //   title: "Status",
      //   dataIndex: "status",
      //   key: "status",
      //   width: "40%",
      // },
      // {
      //   title: "Action",
      //   dataIndex: "operation",
      //   render: (text, record) =>
      //     this.state.data.length >= 1
      //       ? this.renderActionDropdown(record)
      //       : null,
      // },
    ];
    const { uploading, file } = this.state;
    const props = {
      showUploadList: false,
      beforeUpload: (file) => {
        const isCsv = file.type === ".csv" || file.type === "text/csv";
        if (!isCsv) {
          showErrorToast("You can only upload CSV file!");
          return;
        }
        this.setState((state) => ({
          file: file,
        }));
        return false;
      },
      file,
    };
    let { isFetching } = this.state;
    return (
      <Page title={"010hotline Numbers"}>
        {isFetching ? (
          <Spin></Spin>
        ) : (
          <div>
            {/* <Row style={{ marginTop: "25px" }}>
              <Button
                icon="download"
                onClick={() => this.handleDownload()}
                style={
                  this.props.context.curr_dir === "ltr" &&
                  this.props.context.curr_lang === "en"
                    ? { marginRight: "20px", marginBottom: "25px" }
                    : { marginLeft: "20px", marginBottom: "25px" }
                }
              >
                {" "}
                Download Template
              </Button>
              <Upload {...props}>
                <Button
                  style={
                    this.props.context.curr_dir === "ltr" &&
                    this.props.context.curr_lang === "en"
                      ? { marginRight: "20px", marginBottom: "25px" }
                      : { marginLeft: "20px", marginBottom: "25px" }
                  }
                >
                  <Icon type="upload" style={{ color: "" }} />
                  {this.state.file === null
                    ? "Upload Batch"
                    : this.state.file.name}
                </Button>
              </Upload>
              {this.state.file === null ? null : (
                <Fragment>
                  <Button
                    icon="delete"
                    className="button-delete"
                    onClick={this.handleCancel}
                    style={
                      this.props.context.curr_dir === "ltr" &&
                      this.props.context.curr_lang === "en"
                        ? { marginRight: "20px", marginBottom: "25px" }
                        : { marginLeft: "20px", marginBottom: "25px" }
                    }
                  ></Button>

                  <Button
                    type="primary"
                    onClick={this.handleUpload}
                    loading={uploading}
                  >
                    {uploading ? "Uploading" : "Start Upload"}
                  </Button>
                </Fragment>
              )}
            </Row> */}
            {/* <Row>
              <Button
                className="button-add-account"
                onClick={this.addAccountMSISDN}
                icon="plus"
              />
              <span>Add new MSISDN</span>
            </Row> */}

            <Table
              columns={columns}
              bodyStyle={{
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                borderRadius: "8px",
                marginBottom: "25px",
              }}
              dataSource={this.state.data}
              pagination={{
                current: this.state.pagination.current,
                pageSize: this.state.pagination.pageSize,
                total: this.state.pagination.total,
              }}
              loading={isFetching}
              onChange={this.handleTableChange}
              bordered
              locale={{
                emptyText: (
                  <Empty
                    description={i18next.t("Empty")}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ),
              }}
            />
          </div>
        )}
      </Page>
    );
  }
}

export default withSharedStateConsumer(AccountMSISDNTable);
